var QS = document.querySelector.bind(document);
window.fontsize = 100;
var ISH5 = window.innerWidth < window.innerHeight * 0.75;
export function recalc() {
    if (process.env.NODE_ENV === "development") {
        console.log("recalc");
    }
    var head = document.head;
    var docEl = document.documentElement;
    if (!ISH5) {
        var pcRelativeWidth = Math.floor((window.innerHeight * 7.5) / 14.64);
        var pcFont = pcRelativeWidth / 7.5;
        docEl.style.fontSize = pcFont + "px";
        window.fontsize = pcFont;
        return;
    }
    var metaElem = QS("meta[name=\"viewport\"]") ||
        document.createElement("meta");
    metaElem.name = "viewport";
    metaElem.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no");
    head.appendChild(metaElem);
    var _a = docEl.getBoundingClientRect(), width = _a.width, height = _a.height;
    window.docElwidth = width;
    window.docElheight = height;
    console.log("o:", window.orientation, "w:", width, "h:", height);
    var w = width;
    if (w < 320) {
        w = 320;
    }
    var font = (w / 750) * 100;
    docEl.style.fontSize = font + "px";
    var realFont = window.getComputedStyle(docEl).fontSize;
    realFont = parseFloat(realFont.replace("px", ""));
    if (realFont !== font) {
        font = (font * font) / realFont;
        docEl.style.fontSize = font + "px";
    }
    window.fontsize = font;
}
export function listen() {
    recalc();
    var resizeEvt = "orientationchange" in window ? "orientationchange" : "resize";
    window.addEventListener(resizeEvt, recalc, false);
    var handlePageShow = function (e) {
        if (e.persisted) {
            recalc();
        }
    };
    window.addEventListener("pageshow", handlePageShow);
    return function () {
        window.removeEventListener(resizeEvt, recalc, false);
        window.removeEventListener("pageshow", handlePageShow);
    };
}
//# sourceMappingURL=initRem.js.map